import DocumentTextIcon from '@heroicons/react/outline/esm/DocumentTextIcon.js'
import { clsx } from 'clsx'

import { useRouter } from '@tribeplatform/react-sdk'

import { getRandomColorById } from '../../../utils/colors.js'
import type { StaticField } from '../../Views/types.js'
import type { QuickLinksSource } from '../types.js'

interface Props {
  field: StaticField
  source: QuickLinksSource
  highlighted: boolean
  mediaUrl: string
  aspectRatio: StaticField['settings']['aspectRatio']
  preview: boolean
}
export const CardBanner = ({
  field,
  source,
  highlighted,
  mediaUrl,
  aspectRatio,
  preview,
}: Props) => {
  const { Link } = useRouter()

  if (!mediaUrl && !preview) {
    return null
  }

  const { default: defaultUrl } = field
  const fieldMediaUrl = mediaUrl || (preview ? defaultUrl : '')

  return (
    <Link href={source.linkUrl} variant="inherit" tabIndex={-1}>
      <div
        className={clsx(
          'w-full relative',
          aspectRatio || 'aspect-video',
          highlighted && 'border-2 border-focused',
        )}
      >
        <div
          className="w-full h-full flex justify-center items-center"
          style={{ backgroundColor: getRandomColorById(source?.id ?? '') }}
        >
          <DocumentTextIcon className="w-16 h-16 text-white" />
        </div>
        <div
          className="w-full h-full bg-cover bg-center absolute top-0 start-0"
          style={{ backgroundImage: `url(${fieldMediaUrl})` }}
        ></div>
      </div>
    </Link>
  )
}
